module.exports = __webpack_public_path__ + "static/img/skill-Special.4521b104.png";